import React from 'react';

const StatsCard = ({ img, title, count }) => {
  return (
    <div className="stats-card bg-white p-5 2xl:p-6 rounded-2xl flex items-center">
      <div className="min-w-16 w-16 h-16 overflow-hidden rounded-full me-5">
        <img className="w-full h-full" src={img} alt="" />
      </div>

      <div>
        <span className="text-md text-grey font-medium">{title}</span>
        <h1 className="mt-1 2xl:mt-2 text-2xl text-secondary font-extrabold">{count ?? '0'}</h1>
      </div>
    </div>
  );
};

export default StatsCard;
